
// ReportType Model
export class ReportType {
  constructor(data = {}) {
    this.id = data.id || null;
    this.name = data.name || '';
    this.systemPrompt = data.systemPrompt || '';
    this.customEnterpriseInstructions = data.customEnterpriseInstructions || '';
    this.isDefault = data.isDefault || false;
    this.createdBy = data.createdBy || null;
    this.examplesCount = data.examplesCount || 15;
    this.isActive = data.isActive !== undefined ? data.isActive : true;
    this.isFavorite = data.isFavorite || false;
    // UI components rely on description and is_custom fields
    this.description = data.description || '';
    // API may send either is_custom or isCustom. Preserve original field name used by UI
    this.is_custom = data.is_custom !== undefined ? data.is_custom : (data.isCustom || false);
    this.model = data.model || 'gpt-4.1';
    this.temperature = data.temperature || 0.2;
    this.maxTokens = data.maxTokens || 4000;
    this.isJson = data.isJson || false;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
  }
}
